const getUser = () => JSON.parse(localStorage.getItem('user'))
const getAccessToken = () => `Bearer ${getUser()?.accessToken}`
const saveUser = (userData) => {
  localStorage.setItem('user', JSON.stringify(userData))
}
const removeUser = () => {
  localStorage.removeItem('user')
}

export default {
  getUser,
  saveUser,
  removeUser,
  getAccessToken,
}
